/* ==========================================================================
   MSearcherFlight > Client >  Services
   ========================================================================= */

// Modules
const { getService } = require('../../../../services/fetch');

function getAirportByDestination(instance) {
    const { config = {}, location = [] } = instance;
    const { enpoints } = config;

    /* Destination data */
    const { value: valueDestination, kind: typeDestination } = location[1];
    const destinationCode = valueDestination.replace(/ZON_/gi, '');

    /* Build url */
    const url = `${enpoints.airportByDestination}?`.concat(
        `destinationCode=${destinationCode}`,
        `&destinationType=${typeDestination}`
    );

    /* Return Service */
    return getService(instance, url, 'operative');
}

module.exports = {
    getAirportByDestination
};
